export default "__VITE_ASSET__THxIUzOn__"